exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Details{\r\n    float: left;\r\n    text-align: left;\r\n    color: #5c5f62;\r\n    flex-grow: 100;\r\n    width: 84vmin;\r\n}\r\n\r\n.ServiceName{\r\n    font-weight: bold;\r\n    margin: 9vmin 0px 0px 10px;\r\n}\r\n\r\n.ServiceDescription{\r\n    font-size: calc(10px + 1vmin);\r\n    line-height: calc(10px + 2vmin);\r\n    padding-right: 6vw;\r\n    margin: 1vmin 0px 0px 10px;\r\n    color: #5c5f62d6;\r\n}\r\n\r\n", ""]);

// exports
